module.exports = __webpack_public_path__ + "static/media/v5.62dd2af7.mp4";